var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sAlert',{attrs:{"small":"","type":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('Automation.UncnownConditionType'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }